import { StyleSheet } from 'react-native';

import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  root: {
    flex: 0,
    height: 22,
    paddingLeft: 10,
    paddingRight: 10,
    marginTop: 10,
    marginLeft: 30,
    marginBottom: 10
  },
  description: {
    color: PALETTE.loginFooterText
  }
});
